import * as io from 'io-ts';

export const arrayOfStrings = io.array(io.string);
export const nullableArrayOfStrings = io.union([arrayOfStrings, io.null]);
